import { Box } from "@mui/material";
import {
    ProjectDetailDto,
    ProjectRelatedEntitiesContainerDto,
} from "../../../../api/psc";
import { Spinner } from "../../../../components/exports";
import ProjectPrintItem from "../../components/ProjectPrintItem";

type TProps = {
    projectsReady: boolean;
    baseInfo: ProjectRelatedEntitiesContainerDto;
    projectDetails: ProjectDetailDto[];
};

export default function PrintProjectsView({
    baseInfo,
    projectDetails,
    projectsReady,
}: TProps) {
    return (
        <Box>
            {!projectsReady && <Spinner />}

            {projectsReady && (
                <Box>
                    {/*this is required by the server as it will wait for this element to be available*/}
                    <div id="print-ready" />

                    {projectDetails.map((p, i) => {
                        return (
                            <Box sx={{ breakInside: "avoid" }} key={p.hashId}>
                                <ProjectPrintItem
                                    project={p}
                                    baseInfo={baseInfo}
                                />
                            </Box>
                        );
                    })}
                </Box>
            )}
        </Box>
    );
}
